import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import BASE_URL from "components/BaseUrl/apiConfig";
import Navbar from "components/Navbars/IndexNavbar";
import Footer from "components/Footers/Footer";
import Swal from "sweetalert2";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import AnimatedCard from "react-animated-3d-card";
import {
  setLocalStorageData,
  getLocalStorageData,
  resetSessionTimeout,
  removeLocalStorageData,
  setupSessionTimeoutListener,
} from "./localStorageUtil";

export default function Login() {
  const history = useHistory();
  const userNameInputRef = useRef(null);

  const [formData, setFormData] = useState({
    password: "",
    userName: "",
  });

  const [errors, setErrors] = useState({
    password: "",
    userName: "",
  });

  const [hoveredCard, setHoveredCard] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Focus on the userName input when the component mounts
    userNameInputRef.current.focus();

    setupSessionTimeoutListener();
  }, []);

  const handleCardClick = (title, description) => {
    Swal.fire({
      title: title,
      text: description,
      // icon: "info",
      imageUrl: require("assets/img/essentials_small.png"), // Path to your image
      imageWidth: 200, // Adjust the width as needed
      imageHeight: 50, // Adjust the height as needed
      confirmButtonText: "Okay",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear the error for the changed field
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    const newErrors = {};
    if (!formData.userName.trim()) {
      newErrors.userName = "Username is required.";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      // There are validation errors
      setErrors(newErrors);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/api/Users/Login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: formData.userName,
          password: formData.password,
        }),
      });

      if (!response.ok) {
        // Handle unsuccessful login (e.g., display an error message)
        const errorData = await response.json();

        setLoading(false);

        if (errorData.msg === "Please Verify your Email!") {
          history.push("/verifyEmail");

          Swal.fire({
            icon: "error",
            title: "Verify Email",
            text: "Your Email is not Verified. Please Verify your Email! ",
          });

          return;
        } else if (errorData.msg === "Please contact your administrator.") {
          Swal.fire({
            icon: "error",
            title: "Something went wrong.",
            text: "Please contact your administrator.",
          });

          return;
        }

        Swal.fire({
          icon: "error",
          title: "Invalid credentials.",
          text: errorData.msg,
        });

        return;
      }

      const responseData = await response.json();

      if (responseData.success) {
        const userData = responseData.user;
        // Store user data in local storage
        setLocalStorageData({
          userName: userData.userName,
          userId: userData.userId,
          userTypeId: userData.userTypeId,
          groupId: userData.groupId,
        });

        if (userData.userTypeId === 1) {
          history.push("/admindashboard");
        } else {
          // Redirect to the dashboard or desired page
          history.push("/dashboard"); // Replace '/dashboard' with your actual dashboard route
        }

        setLoading(false);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong.",
        text: error,
      });
      setLoading(false);
    }
  };
  const quantityTracking =
    "https://img.freepik.com/free-vector/construction-costs-concept-illustration_114360-7458.jpg?t=st=1721732361~exp=1721735961~hmac=85d296b6dbe5afd37cf638a338191ad86d691904f949a06da60e85227aeb4f71&w=740";

  const imageExpenseTracking =
    "https://img.freepik.com/free-vector/app-monetization-concept-illustration_114360-7464.jpg?t=st=1721732425~exp=1721736025~hmac=98c856370277200b48ca3ecdcb7d9432d04844aa2d27f7507c83c3656236f8c6&w=740";

  const notesimage =
    "https://img.freepik.com/free-vector/kanban-board-with-lists-task-time-management-method-project-process-workflow-optimization-organization-kpi-performance-efficiency_335657-2621.jpg?t=st=1721732163~exp=1721735763~hmac=4a798d835930f92df761145cfb1840b26ebc6f2f5f642b8deef8297fcc7f0181&w=740";

  const documentimg =
    "https://img.freepik.com/free-vector/personal-files-concept-illustration_114360-4503.jpg?t=st=1721732258~exp=1721735858~hmac=0797ed21781d6e8f6fe3894aa91b8b8b4a9c2a0dc0eb4c3c1f3731727f256068&w=740";

  const marketingimg =
    "https://img.freepik.com/free-vector/mobile-marketing-isometric-style_23-2148896785.jpg?t=st=1721731780~exp=1721735380~hmac=1970ddde247891977db59d0761c934196032bd0004759fc7c600ff9f2f5536a2&w=740";

  return (
    <>
      <Navbar />
      <div>
        <div className="container mx-auto mb-3  h-full">
          <div className="flex flex-wrap">
            <div className=" md:block w-full xl:w-8/12 xl:mb-0">
              <div className="p-12 mt-12 ml-auto mr-auto text-center">
                <h2 style={{ fontSize: "45px", color: "black" }}>
                  What you will get inside!
                </h2>
              </div>

              <div className="flex flex-wrap justify-center ">
                {/* First Card */}
                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Expense Tracking",
                        " Details about Expense Tracking where User Can calculate their Credit And Debit balance."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "140px",
                      height: "auto", // Adjusted height to accommodate variable content
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                      display: "flex", // Added display flex to ensure proper alignment
                      flexDirection: "column", // Set flex direction to column for stacking items
                      justifyContent: "center", // Center items vertically
                      alignItems: "center", // Center items horizontally
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1", // Allow front content to grow to fill available space
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1", // Allow back content to grow to fill available space
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    {/* Content for Front */}
                    <img
                      src={imageExpenseTracking}
                      alt="Expense Tracking"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Expense Tracking
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>

                {/* Second Card */}
                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Quantity Tracking",

                        " Here User can Manage Item Quantity and show the item quantity and their amount."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "140px",
                      height: "auto", // Adjusted height to accommodate variable content
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                      display: "flex", // Added display flex to ensure proper alignment
                      flexDirection: "column", // Set flex direction to column for stacking items
                      justifyContent: "center", // Center items vertically
                      alignItems: "center", // Center items horizontally
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1", // Allow front content to grow to fill available space
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                        flexGrow: "1", // Allow back content to grow to fill available space
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    {/* Content for Front */}
                    <img
                      src={quantityTracking}
                      alt="Quantity Tracking"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Quantity Tracking
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>

                {/* Third Card */}
                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Notes management",

                        "User in this page make a imporant notes and show in diffrent colours with the imformation."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "140px",
                      height: "auto",
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                      <img
                      src={notesimage}
                      alt="Notes Tracking"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Notes Management
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>

                {/* Fourth Card */}
                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Document Management",

                        "Here User save ,Edit and also delete Important Documents which is save by User."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "140px",
                      height: "auto",
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                       <img
                      src={documentimg}
                      alt="Document Management"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Document Management
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>

                {/* Fifth Card */}
                <div style={{ marginRight: "20px", marginTop: "20px" }}>
                  <AnimatedCard
                    onClick={() =>
                      handleCardClick(
                        "Marketing Management",
                        " In this functioality, user can verify any Email(Valid or Inavalid), also add message logs and reply messages in threads."
                      )
                    }
                    config={{
                      rotation: 15,
                      transition: {
                        duration: 0.5,
                        timingMode: "ease",
                      },
                      transform: {
                        figureIcon: {
                          rotation: 20,
                          translateZ: 30,
                        },
                        titleTranslateZ: 80,
                        bodyTextTranslateZ: 70,
                      },
                    }}
                    style={{
                      width: "140px",
                      height: "auto",
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                    }}
                    className=""
                    front={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    back={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                     <img
                      src={marketingimg}
                      alt="Marketing Management"
                      className="w-full h-auto object-cover"
                    />

                    <div className="p-1">
                      <h2 className="text-xl font-bold text-center">
                        Marketing Management
                      </h2>
                    </div>
                  </AnimatedCard>
                </div>
              </div>
            </div>

            {/* here is the code of the login section */}
            <div className="w-full xl:w-4/12 px-4">
              <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                <div className="rounded-t mb-0 px-6 py-6">
                  {/* <div className="text-right ">
                    <button
                      //onClick={navigateAddUser}
                      className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                      type="button"
                    >
                      Back
                    </button>
                  </div> */}
                  <div className="text-center mb-3">
                    <h2 className="text-blueGray-800 text-2xl font-bold">
                      Sign in to your account
                    </h2>
                  </div>
                  <hr className="mt-6 border-b-1 border-blueGray-300" />
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                  <form onSubmit={handleSubmit}>
                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="userName"
                      >
                        Username or email
                      </label>
                      <input
                        type="text"
                        name="userName"
                        ref={userNameInputRef}
                        value={formData.userName}
                        onChange={handleChange}
                        className=" border rounded w-full"
                        placeholder="Username or email address"
                      />
                      {errors.userName && (
                        <p style={{ color: "red" }}>{errors.userName}</p>
                      )}
                    </div>
                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase  text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="password"
                      >
                        Password
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className=" border rounded w-full"
                        placeholder="Password"
                      />
                      {errors.password && (
                        <p style={{ color: "red" }}>{errors.password}</p>
                      )}
                    </div>
                    <div className="text-center mt-6">
                      <button
                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                        type="submit"
                      >
                        Sign In
                      </button>
                    </div>
                    <div className="w-full flex flex-wrap mt-6 relative justify-between">
                      <div>
                        <Link to="/forgotpassword" className="text-blue-200">
                          <small>Forgot Password?</small>
                        </Link>
                      </div>
                      <div className="ml-auto">
                        <Link to="/userRegister" className="text-blue-200">
                          <small>Don't have an account? Sign Up</small>
                        </Link>
                      </div>
                      <BlockUiOverlay visible={loading} />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
